class ComplaintAdmModalNewOrder {
    constructor($http, close, complaint, products, shipments, translateService) {
        'ngInject';

        this.$http = $http;
        this.closeCallback = close;

        this.error = false;

        this.complaint = complaint;
        this.products = products;
        this.shipments = shipments;
        this.selectedProducts = [];
        this.selectedShipment = null;

        this.translate = translateService;
    }

    toggleProduct(product) {
        if (this.selectedProducts.indexOf(product.id) > -1) {
            this.selectedProducts.splice(this.selectedProducts.indexOf(product.id), 1);
        } else {
            this.selectedProducts.push(product.id);
        }
    }

    save() {
        if (this.selectedProducts.length === 0 || this.selectedShipment === null || this.selectedShipment === '') {
            this.error = this.translate.t('admpanel.complaints.pleaseSelectAtLeastOneProductAndShipping');

            return;
        }

        this.error = false;

        let products = this.products;
        let selectedProductsWithQuantities = [];
        angular.forEach(this.selectedProducts, function(value, key) {
            let selectedProductQuantity = products.find(x => x.id == value).quantity;
            selectedProductsWithQuantities.push({product_id: value, quantity: selectedProductQuantity});
        });

        this.closeCallback({selectedProducts: selectedProductsWithQuantities, selectedShipment: this.selectedShipment}, 200);
    }

    close() {
        this.closeCallback(false, 200);
    }

    getSelectShipmentPlaceholder() {
        return this.translate.t('admpanel.complaints.selectShipment').toLowerCase();
    }
}

export default ComplaintAdmModalNewOrder;